var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H17.3333C18.0406 4 18.7189 4.28095 19.219 4.78105C19.719 5.28115 20 5.95942 20 6.66667V17.3333C20 18.0406 19.719 18.7189 19.219 19.219C18.7189 19.719 18.0406 20 17.3333 20H6.66667C5.95942 20 5.28115 19.719 4.78105 19.219C4.28095 18.7189 4 18.0406 4 17.3333V6.66667ZM12.8889 5.77778C12.6531 5.77778 12.427 5.87143 12.2604 6.03813C12.0937 6.20483 12 6.43092 12 6.66667C12 6.90241 12.0937 7.12851 12.2604 7.29521C12.427 7.4619 12.6531 7.55556 12.8889 7.55556H15.1876L11.3716 11.3716C11.2096 11.5392 11.12 11.7637 11.1221 11.9968C11.1241 12.2299 11.2176 12.4528 11.3824 12.6176C11.5472 12.7824 11.7701 12.8759 12.0032 12.8779C12.2363 12.88 12.4608 12.7904 12.6284 12.6284L16.4444 8.81244V11.1111C16.4444 11.3469 16.5381 11.573 16.7048 11.7397C16.8715 11.9063 17.0976 12 17.3333 12C17.5691 12 17.7952 11.9063 17.9619 11.7397C18.1286 11.573 18.2222 11.3469 18.2222 11.1111V6.66667C18.2222 6.43092 18.1286 6.20483 17.9619 6.03813C17.7952 5.87143 17.5691 5.77778 17.3333 5.77778H12.8889Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.36078446572ad67214e43e02fde0099f.svg";
export { ForwardRef as ReactComponent };